var React = require('react');

function BackToTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"backToTopIconPath","d":"M13.8663 82.1996C11.3779 84.6703 11.3779 88.6762 13.8663 91.1469C16.3548 93.6177 20.3893 93.6177 22.8777 91.1469L64.5709 49.75L105.122 90.0132C107.611 92.4839 111.645 92.4839 114.134 90.0132C116.622 87.5424 116.622 83.5365 114.134 81.0658L69.9778 37.2237C66.9917 34.2588 62.1502 34.2588 59.1641 37.2237L13.8663 82.1996Z","fill":"white"}));
}

BackToTop.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = BackToTop;

BackToTop.default = BackToTop;
